import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import OfferCard from "@/components/OfferCard";
import { useAuth } from "@/context/AuthContext";
import { useSEO } from "@/lib/useSEO";
import { decideRobots, buildPageMeta } from "@/lib/seoIndex";

export default function FavoritesPage() {
  const { user } = useAuth();
  const { t } = useTranslation();
  useSEO({ robots: decideRobots({ pageType: "account" }), ...buildPageMeta("account") });
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  /* eslint-disable */
  useEffect(() => {
    if (user === false) { nav("/login?redirect=/favorites", { replace: true }); return; }
    if (!user) return;
    setLoading(true);
    api.get("/favorites").then(r => setItems(r.data)).finally(() => setLoading(false));
  }, [user, nav]);
  /* eslint-enable */

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-12" data-testid="favorites-page">
      <p className="eyebrow">{t("favorites.eyebrow")}</p>
      <h1 className="mt-2 text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight">{t("favorites.title")}</h1>
      <p className="mt-2 text-sm text-[#5F6B61]">{t("favorites.subtitle")}</p>

      <div className="mt-10">
        {loading ? (
          <p className="text-[#5F6B61]">{t("favorites.loading")}</p>
        ) : items.length === 0 ? (
          <div className="card-clay p-12 text-center">
            <p className="text-3xl mb-2">💛</p>
            <h3 className="text-xl font-bold">{t("favorites.empty_title")}</h3>
            <p className="text-sm text-[#5F6B61] mt-2">{t("favorites.empty_body")}</p>
            <Link to="/offers" className="btn-pill inline-block mt-6 px-5 py-2.5 bg-[#5B8C66] text-white font-semibold">{t("favorites.browse_offers")}</Link>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map(o => <OfferCard key={o.id} offer={o}/>)}
          </div>
        )}
      </div>
    </div>
  );
}
